import { ComponentSettings } from "../../settings/settings";

const settings = {
  permission: {},
  text: {},
  field: {},
  url: {},
  list: {},
  additionalInfo: {},
};

export const ocComment: ComponentSettings<typeof settings> = settings;
